import { z } from "zod";
import { axiosInstance } from "@/config/axios";
import { objectToCamel } from "ts-case-convert";
import { ContractState } from "@/types/contract";
import { contractSchema } from "@/types/schemas/contract";

const responseSchema = z.object({
  contractRequest: contractSchema,
  sessionKey: z.string().uuid(),
});

export const getRequest = async (uuid: string): Promise<ContractState> => {
  const response = await axiosInstance.get(`/request/${uuid}`);

  const parsedResponse = responseSchema.safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error(parsedResponse.error.issues);
    throw new Error("zod error");
  }

  //currently this behavior is not requested
  //   if (parsedResponse.data.contractRequest.requestStatus === "for_approval") {
  //   throw new Error(BadRequestState);
  // }

  return {
    uuid,
    contract: parsedResponse.data.contractRequest,
    sessionKey: parsedResponse.data.sessionKey,
  };
};
